module.exports = __webpack_public_path__ + "static/pinkfloralbum1-2e45eb18bd45ec0bb9d416620b9f6ed2.jpeg";